import type { PlatformAdapter } from '@blockbattle/platform-adapters';
import { api, ApiError } from './api.js';

type Platform = PlatformAdapter['platform'];

export const buildPlatformShareUrl = (
  platform: Platform,
  startParameter: string,
  launchUrl: string | null | undefined,
  webOrigin = window.location.origin,
): string => {
  if (platform === 'web') {
    const url = new URL(webOrigin);
    url.searchParams.set('start', startParameter);
    return url.toString();
  }
  if (!launchUrl)
    throw new ApiError(
      'PLATFORM_SHARE_UNAVAILABLE',
      platform === 'max'
        ? 'Ссылка на мини-приложение MAX не настроена.'
        : 'Ссылка на VK Mini App не настроена.',
    );
  if (platform === 'max') {
    const url = new URL(launchUrl);
    url.searchParams.delete('startapp');
    url.searchParams.set('start', startParameter.slice(0, 128));
    return url.toString();
  }
  return `${launchUrl.replace(/#.*$/, '')}#${encodeURIComponent(startParameter)}`;
};

let configRequest: ReturnType<typeof api.publicConfig> | null = null;

export const platformShareUrl = async (
  adapter: PlatformAdapter | null,
  startParameter: string,
): Promise<string> => {
  if (!adapter) throw new ApiError('PLATFORM_UNAVAILABLE', 'Платформа ещё не готова.');
  if (adapter.platform === 'vk')
    return buildPlatformShareUrl('vk', startParameter, 'https://vk.ru/app54722196');
  if (adapter.platform === 'web') return buildPlatformShareUrl('web', startParameter, null);
  configRequest ??= api.publicConfig().catch((error: unknown) => {
    configRequest = null;
    throw error;
  });
  const config = await configRequest;
  return buildPlatformShareUrl(
    adapter.platform,
    startParameter,
    config.integrations[adapter.platform]?.launchUrl,
  );
};
